/*
 * The CONSOLE's two languages (vue-spec: sl first, en second). A person's language
 * (`Me.locale`) sets the console after signing in. Not to be confused with the screen's
 * content languages (`enums/language.ts`), which are six.
 */
export enum Locale {
    Sl = 'sl',
    En = 'en',
}

export const LOCALES: Locale[] = [Locale.Sl, Locale.En]

export const DEFAULT_LOCALE = Locale.Sl

/** The BCP 47 tag Intl and the `lang` attribute are given for each language. */
export const INTL_LOCALE: Record<Locale, string> = {
    [Locale.Sl]: 'sl-SI',
    [Locale.En]: 'en-GB',
}
